import { Component, Optional, Self, input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl } from '@angular/forms';
import { VehicleCategoryListItem } from '@app/core/models/common.model';
import { IftaLabelModule } from 'primeng/iftalabel';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-vehicle-category-select',
  standalone: true,
  templateUrl: './vehicle-category-select.component.html',
  imports: [FormsModule, IftaLabelModule, SelectModule]
})
export class VehicleCategorySelectComponent implements ControlValueAccessor {
  vehicleCategories = input.required<VehicleCategoryListItem[]>();
  label = input.required<string>();
  inputId = input.required<string>();
  placeholder = input<string>('Select a Vehicle Category');

  value: string | null = null;

  // Registering the value accessor here (instead of via NG_VALUE_ACCESSOR) lets us
  // inject NgControl to mirror the outer control's validation status onto the inner
  // p-select — otherwise the p-select is bound to its own validator-less ngModel and
  // always renders as valid. Must be @Self to avoid grabbing a parent NgControl.
  constructor(@Self() @Optional() public readonly ngControl: NgControl | null) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  private onChange = (_: string | null) => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onTouched = () => {};

  writeValue(value: string | null): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onModelChange(value: string | null): void {
    this.value = value;
    this.onChange(value);
  }

  onBlur(): void {
    this.onTouched();
  }
}
